function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "0,85.167 18.68,96.147 18.68,93.437 23.613,96.147 26.391,92.306 31.341,93.437 31.341,97.239  37.915,97.239 39.013,101.646 34.079,107.146 70.337,123.608 128.582,171.424 133.532,178.015 162.102,153.824 178.026,135.715  179.124,123.608 181.868,120.875 189.551,124.729 196.17,118.143 196.17,115.371 200,112.644 200,107.146 196.17,101.646  194.512,93.437 197.268,84.063 196.17,67.583 200,56.591 175.261,21.986 163.188,30.229 162.102,34.602 145.056,42.861  141.203,40.106 108.815,34.602 102.177,37.368 100.015,45.594 71.983,64.856 57.682,65.943 52.194,60.444 48.364,73.083  22.561,64.856 15.953,75.821 "
});

var Svg06 = function Svg06(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "COL",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg06, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/06.6ab6b825.svg";
export { ForwardRef as ReactComponent };